<template>
  <v-container class="page-earlypay2 dark-mode">
    <div class="bg"></div>
    <DateSlider
      showFormat="M월 DD일 (ddd)"
      class="width-100 mb-5 mt-5"
      :date="date"
      :max="today"
      @update:date="$router.replace({ query: { date: $event } })"
      @onClickDate="
        $router.push({
          path: '/earlypay/statistics/month',
          query: { date },
        })
      "
      style="margin-bottom: 30px;"
    />
    <DataFetch :date="date">
      <template slot-scope="{ data, isLoading }">
        <div v-if="!isLoading && data">
          <CommonSection v-if="!hideFee">
            <template v-slot:content>
              <DailyTotal :data="data" />
            </template>
          </CommonSection>
          <Payment :data="data.paymentsDetail" :hideFee="hideFee" />

          <CommonSectionLight v-if="showCardDeliveryDeposits">
            <template v-slot:content>
              <TodaysCardDeliveryDeposits
                :date="date"
                @shouldShow="handleShouldShow"
              />
            </template>
          </CommonSectionLight>
        </div>
      </template>
    </DataFetch>

  </v-container>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

const today = moment().format('YYYY-MM-DD')

/**
 * 정산 페이지는 미래 날짜 조회 불가하므로
 * 쿼리스트링으로 받은 date 날짜 검사
 */
function queryNavigationGuard(to, from, next) {
  const date = to.query.date
  if (!date) {
    // 쿼리에 날짜가 없으면 route객체에 오늘 날짜 정보만 넣어서 보내줌
    to.query.date = today
    return next()
  } else if (isNaN(Date.parse(date)) || moment(date).isAfter(today)) {
    // 날짜 형식이 아니거나 오늘 이후인 경우 오늘 날짜 페이지로 이동
    return next({ path: `${to.path}?date=${today}` })
  }

  next()
}

export default {
  components: {
    DateSlider: () => import('@/components/earlypay/template/DateSlider.vue'),
    DataFetch: () => import('@/components/earlypay/DataFetch.vue'),
    CommonSection: () => import('@/components/earlypay/template/CommonSection.vue'),
    CommonSectionLight: () => import('@/components/earlypay/template/CommonSectionLight.vue'),
    DailyTotal: () => import('@/components/earlypay/template/DailyTotal.vue'),
    Payment: () => import('@/components/earlypay/template/EarlypayPayment.vue'),
    TodaysCardDeliveryDeposits: () => import('@/components/earlypay/template/TodaysCardDeliveryDeposits.vue'),  
  },
  data() {
    return {
      date: this.$route.query.date,
      today,
      offer: null,
      showCardDeliveryDeposits: true,
      hideFee: false, // 기본값을 false로 설정
    }
  },
  beforeRouteEnter: queryNavigationGuard,
  beforeRouteUpdate: queryNavigationGuard,
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
      limitTransaction: 'limitTransaction',
    }),
    ...mapState('auth', ['me']),
    ...mapState('myfinbiz', ['organization']),
  },
  methods: {
    ...mapActions('auth', ['getMe', 'updateMe']),
    ...mapActions('contract', ['getLimitTransaction', 'checkExistContract', 'getCurrent']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),

    updateHideFee() {
      if (this.me && this.me.isEarlyPaymentFeeHidden !== null) {
        this.hideFee = this.me.isEarlyPaymentFeeHidden;
      } else if (this.organization && this.organization.isEarlyPaymentFeeHidden !== null) {
        this.hideFee = this.organization.isEarlyPaymentFeeHidden;
      } else {
        this.hideFee = false;
      }
    },
    handleShouldShow(value) {
      this.showCardDeliveryDeposits = value;
    },
    async checkContractRequirements() {
      try {
        console.log('~~~~~~~~~~~ this.limitTransaction', this.limitTransaction)
        // 계약서 체크
        if (!this.limitTransaction || !this.limitTransaction.contract || this.limitTransaction.remainExpireDays < 0) {
          console.log('계약서 문제 발생')
          await this.getLimitTransaction()
        }
        const limitTransaction2 = await this.getContractsAgreementsMyfinbizService()

        if (
          (await this.checkExistContract(this.limitTransaction) === false) || 
          (await this.checkExistContract(limitTransaction2) === false)
        ) {
          console.log('계약서 작성 필요:', limitTransaction2)
          await this.$router.replace({
            path: '/signup/limit-transaction',
            query: { next: '/earlypay' },
          })
          return true
        }
        return false
      } catch (error) {
        console.error('checkContractRequirements error:', error)
        return true
      }
    },
  },
  watch: {
    contractCurrent: {
      deep: true,
      immediate: true,
      async handler(v) {
        if (!v) {
          return
        }
        // 선정산이 꺼져있으면 강제로 메인으로 이동시킨다
        if (v.isEarlyPaymentEnabled === false) {
          await this.$router.replace('/')
        }
      },
    },
    me: {
      immediate: true,
      handler(newMe) {
        this.updateHideFee();
      }
    },
    organization: {
      immediate: true,
      handler(newOrganization) {
        this.updateHideFee();
      }
    }
  },
  async created() {
    await this.updateMe()
    
    // 계약서 체크 추가
    const shouldRedirect = await this.checkContractRequirements()
    if (shouldRedirect) {
      return
    }

    console.log('me:', this.me)
    console.log('organization:', this.organization)
  },
}
</script>

<style lang="scss" scoped>
.page-earlypay2.dark-mode {
  background-color: #ccd0d1;  // 더 어두운 그레이-블루
  min-height: calc(100vh - 56px);
  margin: 0;
  padding-top: 20px;

  // 다크 모드에서의 컴포넌트 스타일 오버라이드
  :deep .section-container section {
    background-color: #ffffff;  // 더 어두운 화이트
    color: #2C3E50;  // 더 진한 네이비 텍스트
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);  // 그림자 강도 증가

    .layout {
      color: #2C3E50;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .layout.subtitle {
      font-size: 13px;
    }

    .layout.subtitle::before {
      content: '└';
    }

    p:last-child {
      color: #7F8C8D;
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 12px;
      text-align: center;  // 더 진한 회색
    }
    
    img.icon {
      width: 17px;
      margin-right: 5px;
    }
  }

  // 기존 스타일 유지
  @media screen and (max-width: 319px) {
    padding: 12px 0;
  }
}
</style>
